import { TOGGLE_FEATURES } from 'configs/toggle-feature'
import { useDesktopView } from 'utils/hooks/useDesktopView'

export const useDesktopForYouTabToggle = () => {
  const isEnabled = useDesktopView(
    TOGGLE_FEATURES.PELATIHAN_MANDIRI_DESKTOP_FOR_YOU
  )

  return {
    isEnabled,
  }
}
